import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "./Kontakt.css";

export default function Kontakt() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    hp: "",
  });
  const [sending, setSending] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.hp && formData.hp.trim() !== "") {
      alert("Vielen Dank! Deine Nachricht wurde gesendet.");
      setFormData({ name: "", email: "", message: "", hp: "" });
      return;
    }

    setSending(true);

    try {
      const SERVICE_ID = "service_gcqw6vm";
      const TEMPLATE_ID = "template_gsr5s26";
      const PUBLIC_KEY = "Lq1zYtLhZCAAf-VGF";

      await emailjs.send(
        SERVICE_ID,
        TEMPLATE_ID,
        {
          name: formData.name,
          email: formData.email,
          message: formData.message,
        },
        { publicKey: PUBLIC_KEY }
      );

      alert(`Vielen Dank, ${formData.name}! Deine Nachricht wurde gesendet.`);
      setFormData({ name: "", email: "", message: "", hp: "" });
    } catch (err) {
      console.error(err);
      alert("Senden fehlgeschlagen. Bitte später erneut versuchen.");
    } finally {
      setSending(false);
    }
  };

  return (
    <main className="kontakt-container">
      <h1>Kontakt</h1>

      <section className="kontakt-info">
        <p>
          STG Diver Duck Berlin e.V.<br></br>
          c/o Hans-Joachim Weidner<br></br>
          Seestr. 98,
          <br />
          15738 Zeuthen
        </p>
        <p>
          E-Mail: <a href="mailto:diver.duck@web.de">diver.duck@web.de</a>
        </p>
      </section>

      <form className="kontakt-formular" onSubmit={handleSubmit}>
        <label className="hp-field" aria-hidden="true" tabIndex={-1}>
          Bitte dieses Feld leer lassen:
          <input
            type="text"
            name="hp"
            autoComplete="off"
            value={formData.hp}
            onChange={handleChange}
          />
        </label>

        <label>
          Name:
          <input
            type="text"
            name="name"
            required
            value={formData.name}
            onChange={handleChange}
          />
        </label>
        <label>
          E-Mail:
          <input
            type="email"
            name="email"
            required
            value={formData.email}
            onChange={handleChange}
          />
        </label>
        <label>
          Nachricht:
          <textarea
            name="message"
            required
            value={formData.message}
            onChange={handleChange}
          />
        </label>
        <button type="submit" disabled={sending}>
          {sending ? "Wird gesendet…" : "Nachricht senden"}
        </button>
      </form>
    </main>
  );
}
